"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDrillEventData = exports.applyDrillableItems = exports.getHeadlineData = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var calculateXirr_1 = require("./calculateXirr");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var computeXirr = function (executionData) {
    // prevent errors on invalid inputs
    if (!executionData || !executionData.length) {
        return NaN;
    }
    var transactions = executionData
        .map(function (datum) { return ({
        amount: datum.value != null ? Number.parseFloat(datum.value.toString()) : 0,
        date: datum.date,
    }); })
        .filter(function (datum) { return datum.amount !== 0; }) // zero values are irrelevant to XIRR computation, filter them out here to avoid useless Date parsing later
        .map(function (_a) {
        var amount = _a.amount, date = _a.date;
        return ({
            amount: amount,
            when: new Date(date),
        });
    });
    return calculateXirr_1.calculateXirr(transactions);
};
function getExecutionData(dv) {
    var headerItems = dv.meta().attributeHeaders()[0][0]; // TODO: is there a better way to do this?
    var data = dv.rawData().singleDimData();
    return headerItems
        ? headerItems.map(function (item, index) {
            var value = data[index];
            ts_invariant_1.default(value !== undefined, "Undefined execution value data for XIRR transformation");
            ts_invariant_1.default(item.attributeHeaderItem, "Missing expected attributeHeaderItem");
            return {
                date: item.attributeHeaderItem.name,
                value: value,
            };
        })
        : [];
}
/**
 * Get HeadlineData used by the {@link Headline} component.
 *
 * @param dataView - data to visualize
 * @param intl - Required localization for compare item title
 */
function getHeadlineData(dataView) {
    var dv = sdk_ui_1.DataViewFacade.for(dataView);
    var measure = dv.meta().measureDescriptors()[0];
    var executionData = getExecutionData(dv);
    var value = computeXirr(executionData);
    return {
        primaryItem: {
            localIdentifier: measure.measureHeaderItem.localIdentifier,
            title: measure.measureHeaderItem.name,
            value: value ? String(value) : null,
            format: measure.measureHeaderItem.format,
            isDrillable: false,
        },
    };
}
exports.getHeadlineData = getHeadlineData;
/**
 * Take headline data and apply list of drillable items.
 * The method will return copied collection of the headline data with altered drillable status.
 *
 * @param headlineData - The headline data that we want to change the drillable status.
 * @param drillableItems - list of drillable items
 * @param dataView - data visualized by the headline
 * @returns altered headlineData
 */
function applyDrillableItems(headlineData, drillableItems, dataView) {
    var dv = sdk_ui_1.DataViewFacade.for(dataView);
    var data = cloneDeep_1.default(headlineData);
    var primaryItem = data.primaryItem;
    var primaryItemHeader = dv.meta().measureDescriptors()[0];
    if (!isEmpty_1.default(primaryItem) && !isEmpty_1.default(primaryItemHeader)) {
        primaryItem.isDrillable = sdk_ui_1.isSomeHeaderPredicateMatched(drillableItems, primaryItemHeader, dv);
    }
    return data;
}
exports.applyDrillableItems = applyDrillableItems;
/**
 * Build drill event data (object with execution and drill context) from the data obtained by clicking on the {@link Xirr}
 * component an from the execution objects.
 *
 * @param itemContext - data received from the click on the {@link Xirr} component.
 * @param dataView - data visualized by the headline
 */
function buildDrillEventData(itemContext, dataView) {
    var dv = sdk_ui_1.DataViewFacade.for(dataView);
    var measureHeaderItem = dv.meta().measureDescriptor(itemContext.localIdentifier);
    if (!measureHeaderItem) {
        throw new Error("The metric uri has not been found in execution response!");
    }
    var intersectionElement = {
        header: measureHeaderItem,
    };
    var drillContext = {
        type: sdk_ui_1.VisualizationTypes.XIRR,
        element: "primaryValue",
        value: itemContext.value,
        intersection: [intersectionElement],
    };
    return {
        dataView: dataView,
        drillContext: drillContext,
    };
}
exports.buildDrillEventData = buildDrillEventData;
//# sourceMappingURL=XirrTransformationUtils.js.map